module.exports = __webpack_public_path__ + "static/media/dvorcikrym.a9a7c432.jpg";